<template>
    <section  class="relative container section-small mbs">

        <!-- {{goingToEventBtn}} -->
        <!-- {{favCookie}} -->
        
        <q-card v-for=" ( session, i ) in sessions" :key="i" :class="{ yellow: session.code === 'break', session: session.code != 'break' } ">

        <div class="session_content">

            <div v-if="session.title === 'Lunch' ">
                <h3>Lunch</h3>
                <h4>Ground Floor North Atrium</h4>
            </div>
            <div v-else-if="session.title === 'Arrival in South Atrium (tea, coffee, pastries/fruit)' ">
                <h3>Arrival (tea, coffee, pastries/fruit)</h3>
                <h4>Business School, Ground Floor South Atrium (top end)</h4>
            </div>
            <div v-else-if="session.title === 'Drinks reception' ">
                <h3>Drinks Reception</h3>
                <h4>Ground Floor North Atrium</h4>
            </div>
            <div v-else-if="session.title === 'Welcome' ">
                <h3>Welcome</h3>
                <h4>BS G.26 Lecture Theatre</h4>
            </div>
            <div v-else-if="session.title === 'Tea, coffee, biscuits' ">
                <h3>Morning Break (tea, coffee, biscuits)</h3>
                <h4>Ground Floor North Atrium</h4>
            </div>
            <div v-else-if="session.title === 'Keynote: Paul Ashwin'">
                <h3>Keynote: Professor Paul Ashwin, Lancaster University</h3>
                <h4>BS G.26 Lecture Theatre</h4>
                <q-list class="rounded-borders">
                    <q-expansion-item
                            expand-separator
                            icon="sunny"
                            label="What could it take to build a transformational learning community?"
                            header-class="dropdown-colour-keynote text-white"
                        >
                            <q-card class="session-content keynote_programme">
                            <q-card-section>
                                <h4>Abstract</h4>
                                <p>Manchester Metropolitan’s 2030 strategy has an ambitious mission to build a transformational learning community. In this keynote, I will consider what it might take to translate this mission into meaningful action. I will argue that such a mission requires a clear understanding of who the students are who will study each programme, a vision of how each programme offers these students access to powerful knowledge that will transform what they can do in the world, and a sense of who these students will become through their engagement with this transformational knowledge. This involves a collective approach to curriculum development that involves academics, students, support staff as well as an understanding of the experiences and needs of alumni and employers. Such work is an ongoing, intellectual and emotional project that focuses on how engagement with higher education can transform the world and students’ lives and goes to the heart of the contribution that higher education can make to society.</p>
                                <h4>Bio</h4>
                                <p>Paul Ashwin is Professor of Higher Education and Head of the Department of Educational Research, Lancaster University. He is Deputy Director of the Centre for Global Higher Education, an ESRC-funded research centre involving 10 international universities. Paul’s research is focused on the educational role of higher education. His book, ‘Transforming University Education: A Manifesto’ (2020), argues for a focus on the educational, rather than economic, purposes of university degrees in order to understand their transformational impact on students and societies. He is also the lead author on Reflective Teaching in Higher Education (2015, 2020) written by an international team to support the development of research-informed university teaching.</p>
                            </q-card-section>
                            </q-card>
                        </q-expansion-item>
                        <h4 class="q-mt-lg">Presentation</h4>
                            <q-btn href="https://utaresources.mmu.ac.uk/documents/leed-conference-23-presentations/Building%20a%20transformational%20learning%20community%20-%20Manchester%20Met%20-%20June%202023%20-shared.pptx" no-caps class="button q-mt-sm" color="primary">Download presentation</q-btn>
                </q-list>
            </div>

            <div v-else>
                <h3>{{ session.title }}</h3>
                <p class="q-mb-lg"><b>Themes:</b> {{ session.themes }}</p>
            </div>

            <div  v-for="(sesh, i) in session.childsessions" :key="i">
                <q-separator />
                <q-list  class="rounded-borders">
                    <q-expansion-item
                        expand-separator
                        :default-opened = "test"
                        icon="sunny"
                        :label="sesh.title" 
                        header-class="dropdown-colour text-white"
                    >
                        <q-card class="session-content">
                        <q-card-section>
                            <h4>Lead presenter</h4>
                            <p v-html="highlightMatchedText(sesh.full_name, i)"></p>
                            <h4 v-show="sesh.facilitators.length > 0">Co-contributors</h4>
                            <p><span v-for="(fac, i) in sesh.facilitators" :key="i" ><span v-html="highlightMatchedText(fac.name, i)"></span><span v-if="i < sesh.facilitators.length - 1">, </span> </span></p>
                            <h4>Abstract</h4>
                            <div style="margin-bottom: 2rem;" v-html="sesh.description"></div>
                            <h4>Themes</h4>
                            <q-chip 
                            size="lg" 
                            v-for="(fac, i) in sesh.themes" 
                            :key="i" 
                            color="primary" 
                            text-color="white" 
                            icon="done">
                            {{ fac.theme }}
                        </q-chip>

                        <div v-if="sesh.presentation">
                            <h4 class="q-mt-lg">Presentation</h4>
                            <q-btn :href="sesh.presentation" no-caps class="button q-mt-sm" color="primary">Download presentation</q-btn>
                        </div>
                        </q-card-section>
                        </q-card>
                    </q-expansion-item>
                </q-list>

            </div>

        </div>

        <div class="session_time_container" >
            <div class="session_time">
            <div class="session_time_block"><span>{{ session.start_time.slice(0, 5) }}</span> <span>{{ session.end_time.slice(0, 5) }}</span> </div>
                <div v-if="session.code != 'break'">
                    <hr>
                    <div>Room <br> BS{{ session.room }}</div>
                    <hr>
                    <div>{{ session.session_format }}</div>
                </div>
            </div>
        </div>

        <div v-if="session.code != 'break'" class="session_img_container">
            <div class="session_img">
                <div class="session_code">{{ session.code }}</div>
                <img :src="session.image" :alt="session.title">
            </div>
        </div>

        <div v-else class="session_img_container">
            <div class="session_img">
                <div class="session_code"> 
                    <img v-if="session.title === 'Lunch'" src="../assets/food.svg" alt="">
                    <img v-if="session.title === 'Tea, coffee, biscuits' || session.title === 'Arrival in South Atrium (tea, coffee, pastries/fruit)'" src="../assets/tea.svg" alt="">
                    <img v-if="session.title === 'Keynote: Paul Ashwin'" src="../assets/smily_face.svg" alt="">
                    <img v-if="session.title === 'Drinks reception'" src="../assets/drinks_reception.svg" alt="">
                    <img v-if="session.title === 'Welcome'" src="../assets/sun.svg" alt="">
                </div>
                
                <!-- <img :src="session.image" :alt="session.title"> -->
            </div>
            
        </div>

        </q-card>
    </section>
</template>

<script setup>

    import { computed, ref } from "vue";
    import axios from "axios";
    import { useQuasar } from 'quasar';
    import Cookies from 'js-cookie'

    const props = defineProps(['sessions', 'search', 'openAccordians'])

    const favCookie = Cookies.get('name')

    console.log('from cookie', favCookie)

    const $q = useQuasar()

    const goingToEventBtn = ref([])

    const sessionsLength = ref([])

    const testFunction = async () => {
        const response = await axios.get(`https://www.utaresources.mmu.ac.uk/leed-conference-23-test/server/public/api/session`)
        sessionsLength.value = response.data
        sessionsLength.value.forEach(i => 
            goingToEventBtn.value.push(false)
        )
        if(favCookie) {
            goingToEventBtn.value = [...JSON.parse(favCookie)]
        }
    }

    testFunction()

    // console.log(goingToEventBtn.value)
    
    
    const test = props.openAccordians
    
    const addToGoingList = (id, fav) => {

        Cookies.set('name', JSON.stringify(goingToEventBtn.value))
        
        console.log(id, fav, goingToEventBtn.value[id])

        try {
            if(fav <= 0 && goingToEventBtn.value[id] === false) {
                axios({
                    method: 'put',
                    url: `https://www.utaresources.mmu.ac.uk/leed-conference-23-test/server/public/api/update/${id}`,
                    data: {
                    "fav" : fav
                    }
                });
            } if (goingToEventBtn.value[id] === true) {

                axios({
                    method: 'put',
                    url: `https://www.utaresources.mmu.ac.uk/leed-conference-23-test/server/public/api/update/${id}`,
                    data: {
                    "fav" : fav += 1
                    }
                });
                
            } else {

                axios({
                    method: 'put',
                    url: `https://www.utaresources.mmu.ac.uk/leed-conference-23-test/server/public/api/update/${id}`,
                    data: {
                    "fav" : fav -= 1
                    }
                });
            }

        } catch (error) {
            console.error(error);
        }
    }

    const highlightMatchedText = (result, i) => {
        if(props.openAccordians === true || props.search === '') {
            // Highlight the matched text in the search results
            const regex = new RegExp(props.search, 'gi');
            const highlightedText = result.replace(regex, match => `<span class="highlighted">${match}</span>`);
            return highlightedText;

        } else {
            return result
        }
    }

</script>

<style lang="scss">



</style>

